// extracted by mini-css-extract-plugin
module.exports = {"studentList":"StudentList_studentList__3y1F4","studentItem":"StudentList_studentItem__1lPHx"};